export const HeaderModelContainerBuilderComponent = {
  name: '_HeaderModelContainer_',
  canHaveChildren: true,
} as const;

export default HeaderModelContainerBuilderComponent;
